import { configureStore } from '@reduxjs/toolkit';
import allergenceReducer from '@store/slice/allergenceSlice';
import ingredientTypeReducer from '@store/slice/ingredients/ingredientsTypeSlice';
import dietReducer from '@store/slice/dietTypeSlice';
import cuisinesReducer from '@store/slice/cuisineTypeSlice';
import spiceLevelReducer from '@store/slice/spiceLevelSlice';
import mealTypeReducer from '@store/slice/mealTypeSlice';
import foodMenuReducer from '@store/slice/foodMenuSlice';
import ingredientReducer from '@store/slice/ingredients/ingredientsSlice';
import foodCategoryReducer from '@store/slice/foodCategorySlice';
import userProfileReducer from '@store/slice/userProfileSlice';
import customerPreferencesReducer from '@store/slice/customerPreferencesSlice';
import addressReducer from '@store/slice/AddressSlice/addressSlice';
import cityReducer from '@store/slice/citySlice';
import addressTypeReducer from '@store/slice/AddressSlice/addressTypeSlice';
import foodListingReducer from '@/store/slice/foodListingSlice';
import foodApprovelRqReducer from '@store/slice/foodApprovalRqSlice';
import bankReducer from '@store/slice/CookSlice/bankDetailsSlice';
import areaCodeReducer from '@store/slice/AddressSlice/areaCodeSlice';
import foodMenuItemApprovalReducer from '@store/slice/FoodMenuItem/foodMenuItemApprovalSlice';
import foodMenuItemReducer from '@store/slice/FoodMenuItem/foodMenuItemSlice';
import customSearchFoodMenuItemReducer from '@store/slice/CookSlice/customSearchFoodMenuItem';
import CustomerReducer from '@store/slice/CustomerSlice/customerSlice';
import AreaManagerReducer from '@store/slice/AreaManager/areaManagerSlice';
import foodScheduleReducer from '@store/slice/FoodSchedule/foodScheduleSlice';
import cookReducer from '@store/slice/CookSlice/AddCookSlice';
import basicIngredientsFoodMenuReducer from '@/store/slice/ingredients/basicIngredientsFoodMenuSlice';
import countryReducer from '@store/slice/AddressSlice/countrySlice';
import documentTypeReducer from '@store/slice/Kyc/documentTypeSlice';
import customSearchFoodScheduleReducer from '@store/slice/FoodSchedule/customSearchFoodScheduleSlice';
import CustomerOrderReducer from '@/store/slice/FoodOrder/customerOrderSlice';
import CustomerOrderItemReducer from '@store/slice/FoodOrder/customerOrderItemSlice';
import CustomerCartReducer from '@store/slice/FoodOrder/customerCartSlice';
import CustomerCartItemReducer from '@store/slice/FoodOrder/customerCartItemSlice';
import customSearchAddressReducer from '@store/slice/AddressSlice/customSearchAddressSlice';
import secondaryDietTypeReducer from '@store/slice/secondaryDietType';
import weeklyScheduleReducer from '@store/slice/WeeklySchedule/weeklyScheduleSlice';
import customSearchWeeklyScheduleReducer from '@store/slice/WeeklySchedule/customSearchWeeklyScheduleSlice';
import WeeklyFoodScheduleFeedSliceReducer from './slice/WeeklySchedule/customeSearchWeeklyFoodSchedle';
import customSearchWeeklyScheduleDatesReducer from '@store/slice/WeeklySchedule/customSearchWeeklyScheduleDates';
import dashboardReducer from '@store/slice/Dashboard/dashboardSlice';
import packUnitsSliceReducer from './slice/packUnitsSlice';
import cookKycDocumentReducer from '@store/slice/Kyc/cookKycDocumentSlice';
import AreaManagerDeliveriesReducer from '@/store/slice/AreaManager/areaManagerDeliveriesSlice';
import CustomSearchCustomerCookReviewsReducer from '@store/slice/CookReviews/customSearchCustomerCookReviewSlice';
import CustomSearchCustomerAreaManagerReviewsReducer from '@store/slice/AreaManagerReviews/customSearchCustomerAreaManagerReviewSlice';
import customSearchCustomerFoodReviewsReducer from '@store/slice/FoodMenuItemReviews/customSearchFoodReviewSlice';
import AreaManagerCoverageReducer from '@store/slice/AreaManagerCoverage/areaManagerCoverageSlice';
import SettingsKeyReducer from '@store/slice/SettingsKey/settingsKeySlice';
import DeliveryAreaDiscountsReducer from '@/store/slice/Discounts/deliveryAreaDiscountsSlice';
import DeliveryChargesReducer from '@store/slice/Discounts/deliveryChargesSlice';
import CookMenuApprovalsReducer from '@store/slice/CookMenuApprovals/cookMenuApprovalsSlice';
import promotionsReducer from '@store/slice/Promotions/promotionsSlice';
import payoutReducer from '@store/slice/Payout/payoutSlice';
import DiscountCouponReducer from '@store/slice/DiscountCoupons/discountCouponsSlice';
import TermsAndConditionsReducer from '@store/slice/TermsAndConditions/termsAndConditionsSLice';
import ConvenienceFeesSliceReducer from './slice/ConvenienceFees/convenienceFeesSlice';
import VersionManagementReducer from './slice/VersionManagement/versionManagementSlice';
import NotificationReducer from '@store/slice/Notifications/notificationSlice';
import PaymentsReducer from '@store/slice/PayementsSlice/paymentsSlice';
import GenderReducer from '@store/slice/Gender/genderSlice';
import videoReducer from '@store/slice/videos/videoSlice';
import menuPollAnalyticsReducer from '@store/slice/MenuPollAnalytics/menuPollAnalyticsSlice';
const store = configureStore({
  reducer: {
    allergence: allergenceReducer,
    cuisines: cuisinesReducer,
    dietType: dietReducer,
    spiceLevel: spiceLevelReducer,
    mealType: mealTypeReducer,
    foodMenu: foodMenuReducer,
    Ingredients: ingredientReducer,
    ingredientTypes: ingredientTypeReducer,
    foodCategory: foodCategoryReducer,
    userProfile: userProfileReducer,
    customerPreferences: customerPreferencesReducer,
    Address: addressReducer,
    city: cityReducer,
    country: countryReducer,
    AddressType: addressTypeReducer,
    foodListing: foodListingReducer,
    foodApprovalRq: foodApprovelRqReducer,
    Banks: bankReducer,
    AreaCode: areaCodeReducer,
    foodMenuItemApproval: foodMenuItemApprovalReducer,
    foodMenuItem: foodMenuItemReducer,
    customSearchFoodMenuItem: customSearchFoodMenuItemReducer,
    Customers: CustomerReducer,
    AreaManager: AreaManagerReducer,
    foodSchedule: foodScheduleReducer,
    cooks: cookReducer,
    basicIngredientsFoodMenu: basicIngredientsFoodMenuReducer,
    documentType: documentTypeReducer,
    customSearchFoodSchedule: customSearchFoodScheduleReducer,
    CustomerOrder: CustomerOrderReducer,
    CustomerOrderItem: CustomerOrderItemReducer,
    CustomerCart: CustomerCartReducer,
    CustomerCartItem: CustomerCartItemReducer,
    customSearchAddress: customSearchAddressReducer,
    secondaryDietType: secondaryDietTypeReducer,
    WeeklySchedule: weeklyScheduleReducer,
    customSearchWeeklySchedule: customSearchWeeklyScheduleReducer,
    weeklyFoodScheduleFeed: WeeklyFoodScheduleFeedSliceReducer,
    WeeklyScheduleDates: customSearchWeeklyScheduleDatesReducer,
    dashboard: dashboardReducer,
    packUnits: packUnitsSliceReducer,
    CookKycDocument: cookKycDocumentReducer,
    AreaManagerDeliveries: AreaManagerDeliveriesReducer,
    CustomSearchCustomerCookReviews: CustomSearchCustomerCookReviewsReducer,
    CustomSearchCustomerAreaManagerReviews: CustomSearchCustomerAreaManagerReviewsReducer,
    customSearchCustomerFoodReviews: customSearchCustomerFoodReviewsReducer,
    AreaManagerCoverage: AreaManagerCoverageReducer,
    SettingsKey: SettingsKeyReducer,
    DeliveryAreaDiscounts: DeliveryAreaDiscountsReducer,
    deliveryCharges: DeliveryChargesReducer,
    CookMenuApprovals: CookMenuApprovalsReducer,
    promotions: promotionsReducer,
    payout: payoutReducer,
    discountcoupons: DiscountCouponReducer,
    termsandconditions: TermsAndConditionsReducer,
    ConvenienceFees: ConvenienceFeesSliceReducer,
    versionManagement: VersionManagementReducer,
    notification: NotificationReducer,
    payments: PaymentsReducer,
    Gender: GenderReducer,
    videos: videoReducer,
    menuPollAnalytics: menuPollAnalyticsReducer,
  },
});
export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
